import {
  takeEvery, call, put, select,
} from 'redux-saga/effects'

import createTrackingMeta from '@doveconviene/sf-web-js-sdk/createTrackingMeta'
import sanitizeObject from '@doveconviene/sf-web-js-sdk/sanitizeObject'

import { tracking as trackingActions } from 'flux/actions'
import { tracking as trackingApi } from 'flux/api'
import {
  tracking as trackingSelectors,
  property as propertySelectors,
  user as userSelectors,
  router as routerSelectors,
  ui as uiSelectors,
} from 'flux/selectors'

import { getI18nMap } from 'utils/i18n'

const password = process.env.REACT_APP_SPLUNK_PASSWORD

export const base = {
  a: 'fv',
  t: 'w',
  lm: 'b',
  la: 0,
}

export const allowedEntries = [
  'a',
  'ts',
  'c',
  't',
  'z',
  'uip',
  'lat',
  'lng',
  'lm',
  'la',
  'st',
  'et',
  'fid',
  'fp',
  'fvk',
  'utm_source',
  'dcid',
  'utm_medium',
  'sp',
  'utm_content',
  'utm_campaign',
  'utm_term',
  'property_id',
  'fbclid',
]

export const structureEntries = (entries, meta) => sanitizeObject({
  ...base,
  ...entries,
  ...meta,
}, allowedEntries)

export function* trackSplunk(action) {
  const { entries } = action.payload
  const dcid = yield select(userSelectors.selectUserId)
  const { lat, lng, label } = yield select(trackingSelectors.selectTrackingGeolocation)
  const {
    id: propertyId,
    extras: { web_network: webNetworkInfo = { active: '0' } } = {},
  } = yield select(propertySelectors.selectProperty) || {}
  const language = yield select(uiSelectors.selectLanguage)
  const i18n = getI18nMap(language)
  const country = `${i18n.ISO639}_${i18n.ISO3166_1}`

  const { utm_source: utmSourceDefault = 'direct', ...query } = yield select(routerSelectors.selectRouterQuery)
  const isWebNetworkActive = webNetworkInfo && webNetworkInfo.active === '1'

  const utm_source = (isWebNetworkActive && webNetworkInfo.utm_source) || utmSourceDefault
  const structuredEntries = structureEntries({
    ...entries,
    c: country,
    dcid,
    utm_source,
    ...(!isWebNetworkActive && { property_id: propertyId }),
    ...query,
    lat,
    lng,
    label,
  }, createTrackingMeta(password))
  const customTrackingUrl = isWebNetworkActive && webNetworkInfo.splunk_tracking_url
  try {
    yield call(trackingApi.trackSplunk, structuredEntries, customTrackingUrl)
  } catch (e) {
    yield put(trackingActions.trackingError(e, action))
  }
}

export default function* () {
  yield takeEvery(trackingActions.types.SPLUNK, trackSplunk)
}
